import type { DocumentFromResponse } from 'shared/features/documents/documents.types';

export const getApplicabilityDate = ({ document }: { document: DocumentFromResponse }) => {
  return document.applicability_date;
};
